<template>
  <InputText
    v-model="searchedString"
    identifier="searchedString"
    :label="text"
    icon="search"
    @onInput="handleOnInput"
  />
</template>
<script>
/**
 * @description Composant d'une barre de recherche
 * @author Maxime Boisvert
 * @vue-prop {String} text - Le texte dans la barre de recherche
 * @vue-prop {Function} filter - La méthode de filtration. Elle reçoit la string recherchée et la liste de données
 * @vue-prop {Array} dataSet - Les données à filtrer
 * @vue-prop {Number} filteringDelay - Le délai de filtration en millisecondes
 * @vue-data {String} searchedString - La chaine de caratères à rechercher
 * @vue-data {Number} timeoutId - L'id du prochain « timeout » de recherche
 * @vue-event {void} filteringDone - Est émis quand le filtrage est fini
 */
import { InputText } from "@/components";
export default {
  name: "SearchBar",
  components: {
    InputText
  },
  props: {
    text: {
      type: String,
      required: true
    },
    filter: {
      type: Function,
      required: true
    },
    dataSet: {
      type: Array,
      required: true
    },
    filteringDelay: {
      type: Number,
      required: false,
      default: 1000
    }
  },
  watch: {
    /**
     * @description Regarde la modification de la chaîne de caractères à chercher
     */
    searchedString() {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(this.startFiltering, this.filteringDelay);
    }
  },
  data() {
    return {
      searchedString: "",
      timeoutId: undefined
    };
  },
  methods: {
    /**
     * @description Gestion de l'évènement OnInput
     * @param data La valeur de l'« input »
     */
    handleOnInput(data) {
      this.searchedString = data.value;
    },
    /**
     * @description Commence la filtration
     */
    startFiltering() {
      this.timeoutId = undefined;
      this.applyFilter();
    },
    /**
     * @description Émet un événement avec le résultat du filtre
     */
    applyFilter() {
      this.$emit(
        "filteringDone",
        this.filter(this.searchedString, this.dataSet)
      );
    }
  }
};
</script>
